import React from 'react'

const Promotion = () => {
    return (
        <div className='box-border h-16 p-[1px] relative rounded-lg text-center promotion-wrapper '>
            <div className='relative p-2 rounded-lg shadow-inner bg-[#1c2d44] inner'>
                <div className='font-bold text-base'>100% Welcome Bonus</div>
                <div>On First Deposit</div>
            </div>
        </div>
    )
}

export default Promotion